// How long after the page has loaded third-party analytics may wait when the visitor does nothing.
export const ANALYTICS_IDLE_DELAY_MS = 4000;

const INTERACTION_EVENTS = ["pointerdown", "keydown", "scroll", "touchstart"];

/**
 * Runs `callback` once, on the first of: a user interaction, or `delay` ms after the page's load event.
 * Used for analytics scripts (Mixpanel ~95 KiB, Google Tag ~177 KiB) so they don't compete with the app's
 * own JS, CSS and fonts for bandwidth and CPU while the first screen is being painted.
 * Events fired in the meantime are queued by the analytics modules and sent once they are ready.
 */
export function runWhenIdle(callback, delay = ANALYTICS_IDLE_DELAY_MS) {
  if (typeof window === "undefined") return;

  let done = false;
  let timer = null;

  const run = () => {
    if (done) return;
    done = true;
    clearTimeout(timer);
    INTERACTION_EVENTS.forEach((name) => window.removeEventListener(name, run));
    window.removeEventListener("load", startTimer);
    callback();
  };

  function startTimer() {
    timer = setTimeout(run, delay);
  }

  INTERACTION_EVENTS.forEach((name) => window.addEventListener(name, run, { passive: true }));
  if (document.readyState === "complete") startTimer();
  else window.addEventListener("load", startTimer);
}
